import { DatePicker } from '../../../../common/DatePicker';
import field from '../../../../hoc/field';
import { DatePickerFieldType } from './DatePickerField.types';

const DatePickerField = (props: DatePickerFieldType) =>
  field(props)(DatePicker);

export default DatePickerField;
